const stateClasses = {};
stateClasses.ACTIVE = 'state-active';
stateClasses.ACTIVE_EXACT = 'state-active--exact';
stateClasses.STICKY = 'state-sticky';
stateClasses.FIXED = 'state-fixed';
stateClasses.MINIMAL = 'state-minimal';
stateClasses.OPEN = 'state-open';
stateClasses.CLOSED = 'state-closed';
stateClasses.HIDDEN = 'state-hidden';
stateClasses.NOANIMATE = 'state-noanimate';
stateClasses.LOADING = 'state-loading';
stateClasses.INITIALIZED = 'state-initialized';
stateClasses.UNINITIALIZED = 'state-uninitialized';
stateClasses.PENDING = 'state-pending';
stateClasses.SUCCESS = 'state-success';
stateClasses.ERROR = 'state-error';
stateClasses.WARNING = 'state-warning';
stateClasses.SELECTED = 'state-selected';
stateClasses.DISABLED = 'state-disabled';
stateClasses.FOCUSED = 'state-focused';
stateClasses.EMPTY = 'state-empty';
stateClasses.HIGHLIGHTED = 'state-highlighted';

const getElementClass = (rootClass, elementName) => {
    return `${rootClass}__${elementName}`;
};

const getModifierClasses = (rootClass, variants) => {
    variants = Array.isArray(variants) ? variants : (variants ? [variants] : []);
    return variants.map(variant => `${rootClass}--${variant}`);
};

// get the current pixel value of a css value, e.g.,
// | 'var(--col-width)'
// | 'min(3vw, var(--grid--margin))'
const getCssValueInPx = (value, $container = document.body, propToTestOn = 'margin') => {
    const $temp = document.createElement('div')
    $container.appendChild($temp)
    $temp.style[propToTestOn] = value
    const computedStyles = window.getComputedStyle($temp)
    const pixels = computedStyles.margin
    $container.removeChild($temp)
    return parseFloat(pixels)
}

const DOC_TITLE_SEPARATOR = '|';

export {
    stateClasses,
    getElementClass,
    getModifierClasses,
    getCssValueInPx,
    DOC_TITLE_SEPARATOR
};
